import { ModelBase, NeoModel } from "@singularsystems/neo-core"

@NeoModel
export default class EmailSignatureTemplate extends ModelBase {

  public emailSignatureTemplateId: number = 0
  public emailSignatureBody: string = ""
  public emailSignatureFriendlyDescription: string = ""
  public emailSignatureCode: string = ""
}